import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-information-panel',
  templateUrl: './information-panel.component.html',
  styleUrls: ['./information-panel.component.scss'],
  standalone: false
})
export class InformationPanelComponent {
  @Input() title = '';
  /** Plain text or HTML rendered with Angular's built-in sanitization. */
  @Input() description = '';
}
